<div class="d-flex flex-column w-100">
    <div class="d-flex mx-auto">
        {{venue.venueStreet}} {{venue.venueStreet2}} {{venue.venueCity}}, {{venue.venueState}} {{venue.venuePostalCode}}
    </div>
    <div class="d-flex mx-auto">
        {{venue.venuePhone}} • {{venue.venueEmail}}
    </div>
    <div *ngIf="venue.venueOnlineOrderUrl" class="d-flex mx-auto">
        <a href="{{venue.venueOnlineOrderUrl}}" target="_blank">Order Online</a>
    </div>

    <div class="mt-3">
        <app-about-me-venue-visit-list [venueKey]="venueKey"></app-about-me-venue-visit-list>
    </div>
</div>
